import { IAction, Status } from '@prometheus/types';
import { getReducerWithProduce } from '@prometheus/utils';
import { UseCdmDataSource } from './useDataSourceList.enum';
import { UseCdmDataSourceInterface } from './useDataSourceList.types';

export const reducer = (state: UseCdmDataSourceInterface, action: IAction) => {
  return getReducerWithProduce(state, (draft: UseCdmDataSourceInterface) => {
    switch (action.type) {
      case UseCdmDataSource.GET_DATA_SOURCES_REQUEST:
        draft.status = Status.IN_PROGRESS;
        draft.list = [];
      case UseCdmDataSource.GET_DATA_SOURCES_REQUEST_DONE:
        draft.status = Status.SUCCESS;
        draft.list = action.payload;
        break;
      case UseCdmDataSource.GET_DATA_SOURCES_REQUEST_FAILED:
        draft.status = Status.ERROR;
        draft.list = [];
        draft.error = action.payload;
    }
  });
};
